import TopNav from "./components/TopNav";
import BreakingBar from "./components/BreakingBar";
import Hero from "./components/Hero";
import FeaturedSection from "./components/FeaturedSection";
import StarSection from "./components/StarSection";
import IndustrySection from "./components/IndustrySection";
import HotRanking from "./components/HotRanking";
import FlashNews from "./components/FlashNews";
import WatchCta from "./components/WatchCta";
import Faq from "./components/Faq";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 font-sans">
      <TopNav />
      <BreakingBar />
      <main>
        <Hero />
        <FeaturedSection />
        <StarSection />
        <IndustrySection />
        <HotRanking />
        <FlashNews />
        <WatchCta />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}